import styled from "styled-components/macro";
import { media, zIndexes } from "../../utils";

export const ModalCloseIcon = styled.button`
  font-size: 36px;
`;

export const ModalCloseButton = styled.button`
  width: 60px;
  height: 60px;
  position: absolute;
  transition: top 300ms ease, left 300ms ease, right 300ms ease;
  cursor: pointer;
  border: 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.color.brandSecondary.gradient};
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: ${({ theme }) => theme.shadow.level["03"]};
  color: ${({ theme }) => theme.color.neutral["08"]};
  font-size: 12px;

  top: -70px;
  right: 16px;
  ${media.lg()} {
    left: -90px;
    top: 0px;
  }
`;

export const ModalHeader = styled.div(() => ({
  position: "relative",
}))

export const ModalHeaderContent = styled.div(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "16px",
  flex: "1 0 0",
  flexDirection: "column",
}))

export const ModalIcon = styled.div(() => ({
  display: "flex",
  width: "44px",
  height: "44px",
  padding: "4.714px 3.143px 5.343px 3.143px",
  justifyContent: "center",
  alignItems: "center",
}))

export const ModalHeaderText = styled.p(({ theme }) => ({
  fontSize: "12px",
  color: theme.color.neutral["03"]
}))

export const ModalHeaderTitle = styled.h3(({theme}) => ({
    fontSize: '24px',
    lineHeight: '150%',
    fontWeight: 500,
    marginBottom: '12px',
    
    [theme.breakpoint.lg()]: {
        fontSize: '28px'
    }
}))

export const ModalHeaderSubTitle = styled.p(({ theme }) => ({
  fontSize: '14px',
    lineHeight: '150%',
    fontWeight: 500,

    [theme.breakpoint.lg()]: {
        fontSize: '16px'
    },
  color: theme.color.neutral["02"],
}))

export const ModalHeaderContentText = styled.div(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "16px",
}))

export const ModalWrapper = styled.div(() => ({
  width: "100%",
  height: "100%",
  position: "relative",
  top: "0",
  bottom: "0",
  display: "flex",
  flexWrapper: "wrap",
  justifyContent: "flex-end",
  zIndex: `${({ zIndex = zIndexes.modal }) => Math.min(zIndex, zIndexes.modal)}`,
  alignItems: "end",
}))

export const ModalBody = styled.div(() => ({
  position: "relative",
  width: "100%",
  height: "100%",
}))

export const ModalBox = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.color.neutral["08"]};
  transition: height 300ms ease-in, width 300ms ease-in;
  padding: 40px 20px;
  height: 0;

  & > .Card__Body {
    overflow-y: auto;
    height: 100%;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  &.active {
    height: 100vh;
    max-height: calc(100vh - 50px);
    animation-name: bottomToTop;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-duration: 300ms;
  }

  ${media.lg()} {
    padding: 56px 60px;
    height: 100vh !important;
    width: 0;
    border-radius: 16px 0px 0px 16px;

    &.active {
      width: initial;
      max-width: 60vw;
      height: 100vh;
      max-height: initial;
      animation-name: rightToLeft;
      animation-iteration-count: 1;
      animation-timing-function: ease-in-out;
      animation-duration: 300ms;
    }
  }

  ${ModalCloseButton} {
    
  }

  @keyframes bottomToTop {
    0% {
      height: -10;
    }
    100% {
      height: 100;
    }
  }

  @keyframes rightToLeft {
    0% {
      width: -10;
    }
    100% {
      width: 100;
    }
  }
`;


